import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { LoadingController, Loading } from 'ionic-angular';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';


class ReportStats{
    view="both";

    constructor(public report:any){

    }

    getMaxSpendings(){
        let spendings_list = this.report.map(entry=>parseInt(entry.val.spendings)).filter(e=>!isNaN(e))
        let maxval = Math.max(...spendings_list);
        console.log(maxval)
        return maxval
    }

    getMaxEarnings(){
        let earnings_list = this.report.map(entry=>parseInt(entry.val.earnings)).filter(e=>!isNaN(e))
        let maxval = Math.min(...earnings_list);
        console.log(maxval)
        return maxval
    }

    getMax(){
        if(this.view == "both")
            return Math.max(-1*this.getMaxEarnings(), this.getMaxSpendings())
        if(this.view == "earnings")
            return -1*this.getMaxEarnings()
        if(this.view == "spendings")
            return this.getMaxSpendings()
    }

    showEarnings(){
        return this.view == "both"|| this.view == "earnings"
    }

    showSpendings(){
        return this.view == "both" || this.view == "spendings"
    }
}

class SpendingsEntry {
    public style:string;
    constructor(public x_offset:number, public width:number, public color:string)  {
        this.style="fill:"+color;
    }
}

class SpendingsBar{

    entries: Array<SpendingsEntry>

    constructor(public spendings: any, max_spendings: number){
        let colors = ["#F44336", "#E91E63", "#9C27B0", "#673AB7",
        "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B",
        "#FFC107", "#FF9800", "#FF5722", "#795548"]

        this.entries = []
        let x_offset = 0
        let idx = 0;
        for(let entry  of spendings){
            let width = 100 * entry.amount / max_spendings

            this.entries.push(new SpendingsEntry(x_offset, width, colors[idx%colors.length]))

            x_offset += width
            idx += 1
        }
        this.entries.push(new SpendingsEntry(x_offset, 100-x_offset, "#CCCCCC"))
    }
}

@Component({
    selector: 'page-report-monthly',
    templateUrl: 'report-monthly.html',
})
export class ReportMonthlyPage {

    report: any;
    stats: ReportStats;

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, public loadingCtrl: LoadingController,
        private _sanitizer: DomSanitizer) {
        this.fetchReport()
        this.stats = new ReportStats([])
    }

    fetchReport() {
        let start_date = new Date(new Date().setFullYear(new Date().getFullYear() + -1));
        let end_date = new Date()

        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()

        this.server.getMonthlyOverviewReport(start_date, end_date).subscribe(
            data => {
                console.log(data.text())
                this.report = this.transform(data.json())
                this.stats = new ReportStats(this.report)
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        )
    }

    transform(dict: Object): Array<any> {
        var a = [];
        for (var key in dict) {
            if (dict.hasOwnProperty(key)) {
                a.push({ key: key, val: dict[key] });
            }
        }
        return a.sort((a,b)=> {return a.key < b.key?1:-1});
    }

    getEarningsBarWidth(earnings:any){
        if(earnings == null)
            return 0;

        var earnings_int = parseInt(earnings)
        let bar = -1*100*earnings_int/this.stats.getMax()
        return bar;
    }

    getSpendingsBar(spendings:any){
        let bar = new SpendingsBar(spendings, this.stats.getMax());
        return bar.entries
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad ReportMonthlyPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/report-monthly/report-monthly.ts